(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["xt-quote-form"] && !Shopify.designMode) return;
  try {
    // Track where the press STARTED so a text-selection drag that ends on
  // the backdrop doesn't close the dialog mid-typing.
  let xtqPressedOnBackdrop = false;
  document.addEventListener('pointerdown', (event) => {
    const dialog = event.target.closest('dialog.xt-quote__dialog');
    if (dialog && event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      xtqPressedOnBackdrop =
        event.clientX < rect.left ||
        event.clientX > rect.right ||
        event.clientY < rect.top ||
        event.clientY > rect.bottom;
    } else {
      xtqPressedOnBackdrop = false;
    }
  });

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-xt-quote-open]');
    if (opener) {
      document.getElementById(opener.dataset.xtQuoteOpen)?.showModal();
      return;
    }

    if (event.target.closest('[data-xt-quote-close]')) {
      event.target.closest('dialog')?.close();
      return;
    }

    // Backdrop click: the dialog element itself is the target only when
    // the click lands outside its content box.
    const dialog = event.target.closest('dialog.xt-quote__dialog');
    if (dialog && event.target === dialog && xtqPressedOnBackdrop) {
      const rect = dialog.getBoundingClientRect();
      const inside =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;
      if (!inside) dialog.close();
    }
  });

  // Archive copy for the xt-quote panel. Shopify stores nothing about a
  // contact-form submission, so without this the notification e-mail is the
  // only record that a request ever existed.
  //
  // The POST cannot happen during submit: preventing the default to await it
  // would bypass Shopify's own captcha listener on the form, and the request
  // would be challenged instead of delivered. Instead the payload is stashed
  // on submit and sent once Shopify has redirected back with a success state —
  // which also means only genuinely accepted submissions are ever archived.

  // Liquid is not rendered inside the theme's javascript bundle, so the
  // worker origin reaches this code through a data attribute on the dialog
  // rather than an interpolated constant.
  const xtqOrigin = () =>
    document.querySelector('[data-xtq-origin]')?.dataset.xtqOrigin || '';
  const XTQ_KEY = 'xtq:pending';
  const XTQ_TTL_MS = 30 * 60 * 1000;

  const xtqRead = () => {
    try {
      const raw = sessionStorage.getItem(XTQ_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  };
  const xtqWrite = (payload) => {
    try { sessionStorage.setItem(XTQ_KEY, JSON.stringify(payload)); } catch (e) { /* private mode */ }
  };
  const xtqClear = () => {
    try { sessionStorage.removeItem(XTQ_KEY); } catch (e) { /* private mode */ }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('.xt-quote__form');
    const dialog = form?.closest('dialog.xt-quote__dialog');
    if (!dialog) return;
    const field = (name) => form.querySelector('[name="contact[' + name + ']"]')?.value ?? '';
    xtqWrite({
      t: Date.now(),
      posted: false,
      productGid: 'gid://shopify/Product/' + dialog.dataset.xtqProduct,
      productTitle: dialog.dataset.xtqTitle || '',
      productUrl: location.origin + location.pathname,
      name: field('name'),
      email: field('email'),
      phone: field('phone'),
      note: field('body'),
    });
  });

  async function xtqFlush() {
    const origin = xtqOrigin();
    if (!origin) return;
    const payload = xtqRead();
    if (!payload) return;
    // `posted` is only set once Shopify confirmed the submission, so a form
    // abandoned at the captcha never reaches the archive.
    if (!payload.posted) return;
    if (Date.now() - payload.t > XTQ_TTL_MS) { xtqClear(); return; }
    try {
      const r = await fetch(origin + '/public/quote', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      // A 4xx will never succeed on retry; anything else stays queued and is
      // retried on the next page view within the TTL.
      if (r.ok || (r.status >= 400 && r.status < 500)) xtqClear();
    } catch (e) {
      console.warn('xt-quote archive failed:', e);
    }
  }

  // Reopen the dialog after Shopify's /contact redirect to surface the
  // success or validation-error state rendered by Liquid.
  const reopenQuoteDialog = () => {
    const flag = document.querySelector('[data-xt-quote-posted], [data-xt-quote-errors]');
    if (flag) flag.closest('dialog')?.showModal();
    if (document.querySelector('[data-xt-quote-posted]')) {
      const payload = xtqRead();
      if (payload && !payload.posted) xtqWrite({ ...payload, posted: true });
    }
    xtqFlush();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reopenQuoteDialog);
  } else {
    reopenQuoteDialog();
  }
  } catch(e) { console.error(e); }
})();

})();
